import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
let TermsOfUse = class TermsOfUse extends Mixins(SegmentAnalyticsMixin) {
    mounted() {
        this.segmentTrack('Chatgenie Website Visit');
    }
};
TermsOfUse = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: { TheFooter },
    })
], TermsOfUse);
export default TermsOfUse;
